export default [
    {id: "1", nm: "German", cod: "de"},
    {id: "2", nm: "English", cod: "en"},
    {id: "3", nm: "Italian", cod: "it"},
    {id: "4", nm: "Greek", cod: "gr"},
    {id: "5", nm: "Albanian", cod: "sq"},
    {id: "6", nm: "Spanish", cod: "es"},
    {id: "7", nm: "Turkish", cod: "tr"},
    {id: "8", nm: "French", cod: "fr"},
    {id: "9", nm: "Arabic", cod: "ar"}
]
